import { memo } from 'react'

const ExpandIcon: React.FC = memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M6.82 9.06C7.12928 8.75072 7.63072 8.75072 7.94 9.06C8.24928 9.36928 8.24928 9.87072 7.94 10.18L3.22 14.9L6.1 14.9C6.54183 14.9 6.9 15.2582 6.9 15.7C6.9 16.1418 6.54183 16.5 6.1 16.5L1.5 16.5C0.947716 16.5 0.5 16.0523 0.5 15.5L0.5 10.9C0.499999 10.4582 0.858172 10.1 1.3 10.1C1.74183 10.1 2.1 10.4582 2.1 10.9L2.1 13.78L6.82 9.06Z"
      fill="currentColor"
    />
    <path
      d="M15.5 0.5C16.0523 0.5 16.5 0.947715 16.5 1.5L16.5 6.1C16.5 6.54183 16.1418 6.9 15.7 6.9C15.2582 6.9 14.9 6.54183 14.9 6.1L14.9 3.22L10.18 7.94C9.87072 8.24928 9.36928 8.24928 9.06 7.94C8.75072 7.63072 8.75072 7.12928 9.06 6.82L13.78 2.1L10.9 2.1C10.4582 2.1 10.1 1.74183 10.1 1.3C10.1 0.858172 10.4582 0.499999 10.9 0.5L15.5 0.5Z"
      fill="currentColor"
    />
  </svg>
))

export { ExpandIcon }
